import { render } from "./ProjectsLaterWork.vue?vue&type=template&id=448dedcb"
import script from "./ProjectsLaterWork.vue?vue&type=script&lang=js"
export * from "./ProjectsLaterWork.vue?vue&type=script&lang=js"

import "./ProjectsLaterWork.vue?vue&type=style&index=0&id=448dedcb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__